import { useCallback } from 'react';

import { useBreakPoints } from 'core';
import { ActionIconProps, CartActionIcon, IndicatorProps, Popover } from 'ui';
import { useClickOutside, useDisclosure } from 'ui/Hooks';

import { useCartStorage } from '../../hooks/useCartStorage';
import { useSubscribeToCartAction } from '../../notifications/actions';
import { useRouter } from '../../router/useRouter';
import { CartsPreview } from './CartsPreview';

const UserCartActionIcon = ({
  actionIconProps,
  indicatorProps,
  className,
}: {
  actionIconProps?: ActionIconProps;
  indicatorProps?: IndicatorProps;
  className?: string;
}) => {
  const { cartsItemsCount } = useCartStorage();
  const { useNavigate } = useRouter();
  const navigate = useNavigate();
  const { isSmallScreen } = useBreakPoints();

  const [opened, { close, open }] = useDisclosure(false);
  const ref = useClickOutside(close);

  const openOnCartUpdate = () => {
    open();
  };

  useSubscribeToCartAction(openOnCartUpdate);

  const handleClick = useCallback(() => {
    navigate('shop/carts');
  }, [navigate]);

  if (isSmallScreen) {
    return (
      <CartActionIcon
        onClick={handleClick}
        onMouseEnter={open}
        count={cartsItemsCount}
        actionIconProps={actionIconProps}
        indicatorProps={indicatorProps}
        className={className}
      />
    );
  }

  return (
    <Popover
      width={410}
      shadow="lg"
      onChange={open}
      opened={opened}
      position="bottom-end"
      withArrow
      arrowOffset={80}
      arrowSize={20}
    >
      <Popover.Target>
        <CartActionIcon
          onClick={handleClick}
          onMouseEnter={open}
          count={cartsItemsCount}
          actionIconProps={actionIconProps}
          indicatorProps={indicatorProps}
          className={className}
        />
      </Popover.Target>
      <Popover.Dropdown ref={ref} style={(theme) => ({ borderRadius: theme.radius.md })}>
        <CartsPreview onClose={close} />
      </Popover.Dropdown>
    </Popover>
  );
};
export { UserCartActionIcon };
